// 针对不同环境生成不同api和websocket接口地址
export function generateProperUrl(type: 'service' | 'websocket') {
  const PRODUCTION_ONLINE =
    process.env.NODE_ENV === 'production' && !process.env.REACT_APP_DEV_SERVER; // 线上环境。
  const DEV_SERVER =
    process.env.NODE_ENV === 'production' &&
    process.env.REACT_APP_DEV_SERVER === 'dev'; // 6.29 dev机器
  const LOCAL_SERVER =
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_DEV_SERVER === 'local'; // 本地开发且本地启动后端服务
  const NORMAL_DEVELOPMENT =
    process.env.NODE_ENV === 'development' && !process.env.REACT_APP_DEV_SERVER; // 本地开发，使用dev机器服务
  if (PRODUCTION_ONLINE) {
    return type === 'service'
      ? 'https://upchat-api.yupoo.com'
      : 'wss://upchat-api.yupoo.com/ws/1';
  }
  if (DEV_SERVER || NORMAL_DEVELOPMENT) {
    return type === 'service'
      ? 'http://10.0.6.29:9997'
      : 'ws://10.0.6.29:9997/ws/1';
  }
  if (LOCAL_SERVER) {
    return type === 'service'
      ? 'http://127.0.0.1:9997'
      : 'ws://127.0.0.1:9997/ws/1';
  }
  return type === 'service'
    ? 'https://upchat-api.yupoo.com'
    : 'wss://upchat-api.yupoo.com/ws/1';
}
